import React from "react";
import T from "prop-types";
import { Modal, Close, Header } from "MODULES/shared/components/Modal";
import { fobFormat } from "LIB/formatters/address";
import { addDays } from "LIB/time";
import { dateFormFormat } from "LIB/formatters/date";
import Form from "./Form";

function ConvertToExchangeModal({ open, close, lineItem, salesOrder }) {
  const coreDueDays = lineItem.core_due_days || 30;
  const days = addDays(new Date(), coreDueDays);

  const initialValues = {
    core_due_days: coreDueDays,
    core_return_date: dateFormFormat(days),
    return_to_fob: fobFormat(salesOrder.ship_to_address)
  };

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Convert To Exchange</h4>
      </Header>
      <Form
        close={close}
        lineItem={lineItem}
        salesOrder={salesOrder}
        enableReinitialize
        initialValues={initialValues}
      />
    </Modal>
  );
}

export default ConvertToExchangeModal;

ConvertToExchangeModal.propTypes = {
  open: T.bool.isRequired,
  close: T.func.isRequired,
  lineItem: T.shape({}),
  salesOrder: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/ConvertToExchange/ConvertToExchangeModal.jsx